import Grid from '@mui/material/Grid'
import { observer } from 'mobx-react-lite'
import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked"
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked"
import Typography from '@mui/material/Typography'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { SvgIconTypeMap } from '@mui/material/SvgIcon'
import Box from '@mui/material/Box'
import { themeConfig }from '@gap/shared/theme'
import { useMemo } from 'react'
import useStore from 'reusable/mobx-store-utils'
import DocEmailAttachmentsTabsStore, { DocEmailAttachmentsTabsStoreProvider, useDocEmailAttachmentsTabsStore } from './DocEmailAttachmentsTabsStore'

interface DocEmailAttachmentsTabProps {
   id: string
   label: string
   icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>
}

export interface DocEmailAttachmentsTabsProps {
   options: DocEmailAttachmentsTabProps[]
   onChange: (val: string) => void
   placeholder?: string
   value: string
}

/**
 * Please supply no more than 2 options, as we only have visual support for 2
 */
export default observer(function DocEmailAttachmentsTabs(props: DocEmailAttachmentsTabsProps) {
   const docEmailAttachmentsTabsStore = useStore(sp => new DocEmailAttachmentsTabsStore(sp), props)

   const Tabs = useMemo(() => {
      return props.options.map(option => <DocEmailAttachmentsTab key={option.id} {...option} />)
   }, [props.options])

   return <DocEmailAttachmentsTabsStoreProvider store={docEmailAttachmentsTabsStore}>
      <Box display="flex">
         {Tabs}
      </Box>
   </DocEmailAttachmentsTabsStoreProvider>
})


const DocEmailAttachmentsTab = observer(function DocEmailAttachmentsTab(props: DocEmailAttachmentsTabProps) {
   const docEmailAttachmentsTabsStore = useDocEmailAttachmentsTabsStore()
   const CheckIcon = docEmailAttachmentsTabsStore.isActive(props.id) ? RadioButtonChecked : RadioButtonUnchecked
   return (
      <Box
         sx={{ borderRadius: '16px', mr: 1, ml: 1, border: `1px solid ${themeConfig.primary[200]}`, width: '400px', height: '75px', cursor: 'pointer' }}
         onClick={docEmailAttachmentsTabsStore.clickHandler}
         data-id={props.id}
         data-testid={`message-dialog-tab-${props.id}`}
      >
         <Grid container sx={{ p: '24px 16px 24px 24px' }}>
            <Grid size={1}>
               <CheckIcon sx={{ height: '24px', width: '24px' }} />
            </Grid>
            <Grid sx={{ pl: 1 }} size={10}>
               <Typography variant="body1">{props.label}</Typography>
            </Grid>
            <Grid size={1}>
               <props.icon sx={{ height: '24px', width: '24px' }} />
            </Grid>
         </Grid>
      </Box>
   )
})
